import type { Media } from '../api/types'
import { dauerText, standbildAdresse } from '../lib/video'
import { useTexte } from '../texte'
import { XIcon } from './Icons'
import { Standbild } from './Standbild'

/**
 * A picture already on the server, as a tile with the cross (1.88.0).
 *
 * **Three places, one tile.** It stood twice almost to the letter -- the
 * point's form (`HighlightBogen`) and the spot's sheet (`Spotblatt`) --
 * and the change of a chat post would have been the third copy. What
 * differs between them is what the cross *does* (ask, detach, delete,
 * or only mark for "Speichern"), and that stays with the caller as
 * `onWeg`. What a tile looks like does not differ, and stands here: the
 * still of a video with its length, a note sign for a recording, the
 * cross in the picture. The tile of a picture on its way up is
 * `Wartekachel`, beside this one.
 */
export function Medienkachel({
  media,
  bezeichnung,
  onWeg,
}: {
  media: Media
  /** What the cross says to a screen reader and as a hint. */
  bezeichnung: string
  onWeg: () => void
}) {
  const t = useTexte().karte.formular
  return (
    <div className="bogen__bild" data-kachel={media.id}>
      {/* **Eine Tonaufnahme hat kein Bild, und das ist kein Fehler**
          (1.35.0). Eine leere Kachel sagte, dass etwas hängt, aber nicht
          was. Ein Notenzeichen und die Dauer sagen es, wie das ▶ beim
          Video. */}
      {media.kind === 'audio' ? (
        <span className="bogen__ton" aria-hidden="true">♪</span>
      ) : (
        /* **Ein Video zeigt sein Standbild, kein leeres Feld.** Die Datei
           selbst hier zu laden hieße, ein paar Dutzend Megabyte zu holen,
           damit ein Daumennagel etwas zeigt. */
        <Standbild src={standbildAdresse(media) ?? ''} />
      )}
      {(media.kind === 'video' || media.kind === 'audio') && (
        <span className="bogen__dauer">
          {media.kind === 'video' ? '▶ ' : '♪ '}
          {media.duration_ms > 0
            ? dauerText(media.duration_ms)
            : media.kind === 'video'
              ? t.video
              : t.tonaufnahme}
        </span>
      )}
      <button
        type="button"
        className="attachment__remove"
        aria-label={bezeichnung}
        title={bezeichnung}
        onClick={onWeg}
      >
        <XIcon size={13} />
      </button>
    </div>
  )
}
